import { Replay, SearchRounded } from '@mui/icons-material';
import { Box, Stepper, Step, StepLabel, Button, Grid, Paper, Input, MenuItem, Select, Stack } from '@mui/material';
import { grid, padding } from '@mui/system';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SubscriptionStep from './Stepper/SubscriptionStep';
import CustomerStep from './Stepper/AddCustomer';
import SummaryStep from './Stepper/SummaryStep';
import CheckoutStep from './Stepper/CheckoutStep';
import CustomerSearchStep from './Stepper/CustomerSearchStep';
import { useRecoilState } from 'recoil';
import { STEPPER_STATE } from '../../service/MobilityVoucherRecoil';

const MobilityVoucherNewOrder = () => {
  const { t } = useTranslation(['mobilityvoucher']);
  const [activeStep, setActiveStep] = useRecoilState(STEPPER_STATE);
  const steps = [
    t("stepper.steps.stepper1"),
    t("stepper.steps.stepper2"),
    t("stepper.steps.stepper3"),
    t("stepper.steps.stepper4")
  ];

  return (
    <>

      <Grid container p={2}>
        <Stepper activeStep={activeStep} sx={{ width: "100%" }}>
          {steps.map((label, index) => {
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            return (
              <Step
                key={label}
                style={{
                  width: `calc(100% / ${steps.length})`
                }}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Grid>


      <Grid container>

        <Grid item xs={12}>
          {activeStep === 0 && <SubscriptionStep />}
          {activeStep === 1 && <CustomerSearchStep />}
          {activeStep === 2 && <SummaryStep />}
          {activeStep === 3 && <CheckoutStep />}
        </Grid>

      </Grid>
    </>
  );
};

export default MobilityVoucherNewOrder;
